import './sentry.client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Providers } from '#containers/providers';
import { initializeGoogleTagManager } from '#modules/analytics/google-tag-manager';

import { Router } from './router';

initializeGoogleTagManager();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <Router />
    </Providers>
  </StrictMode>,
);
